// Logout nunca pode depender da API: com licença vencida o backend pode
// responder 402 (ou a rede cair) e o usuário ficaria preso na sessão.
// A API é chamada para invalidar o refresh token no servidor, mas o erro é
// ignorado e a sessão local é SEMPRE limpa.
export const executaLogout = async ({ chamaApi, limpaSessao }) => {
	try {
		await chamaApi();
	} catch (err) {
		console.warn("Falha ao avisar o servidor do logout; limpando sessão local.", err);
	} finally {
		limpaSessao();
	}
};
